// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAuditActor
 */
export interface IAuditActor {
    /**
     * 
     * @type {number}
     * @memberof IAuditActor
     */
    contact_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAuditActor
     */
    organization_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAuditActor
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAuditActor
     */
    file_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAuditActor
     */
    actor_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IAuditActor
     */
    actor_type?: IAuditActorActorTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAuditActorActorTypeEnum {
    ADMIN = 'ADMIN',
    EMPLOYEE = 'EMPLOYEE',
    PARTNER_USER = 'PARTNER_USER',
    FILE = 'FILE',
    SYSTEM = 'SYSTEM'
}


/**
 * Check if a given object implements the IAuditActor interface.
 */
export function instanceOfIAuditActor(value: object): value is IAuditActor {
    return true;
}

export function IAuditActorFromJSON(json: any): IAuditActor {
    return IAuditActorFromJSONTyped(json, false);
}

export function IAuditActorFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAuditActor {
    if (json == null) {
        return json;
    }
    return {
        
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'file_id': json['file_id'] == null ? undefined : json['file_id'],
        'actor_name': json['actor_name'] == null ? undefined : json['actor_name'],
        'actor_type': json['actor_type'] == null ? undefined : json['actor_type'],
    };
}

export function IAuditActorToJSON(json: any): IAuditActor {
    return IAuditActorToJSONTyped(json, false);
}

export function IAuditActorToJSONTyped(value?: IAuditActor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact_id': value['contact_id'],
        'organization_id': value['organization_id'],
        'employee_id': value['employee_id'],
        'file_id': value['file_id'],
        'actor_name': value['actor_name'],
        'actor_type': value['actor_type'],
    };
}

